/*
 * Panorama Studios
 */

// Disable inital GMap3 loading
$.gmap3(false);

$(document).ready(function () {
	// Responsive menu
	$('header').each(function () {
		var element = $(this),
			body = $(document.body),
			responsiveNav = $('.responsive-nav');

		var toggler = $('<div class="toggler toggler--closed"><span>Menu</span></div>').click(function () {
			body.toggleClass('open');
			responsiveNav.toggleClass('collapsed');
			toggler.toggleClass('toggler--closed');
		}).appendTo(element);
	});

	// Header affix
	$('.frontpage .affix').each(function () {
		var element = $(this);
		var headroom = element.headroom({
			offset: 440
		});
	});

	// Slideshow
	$('.slideshow').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');
		if (element.children('.slide, .slideshow--header__slide, img').length > 1) {
			element.children('.slide').removeClass('slide--active');
			element.lightSlider({
				item: 1,
				slideMargin: 0,
				addClass: cssClass,
				mode: 'fade',
				cssEasing: 'linear',
				auto: true,
				loop: true,
				adaptiveHeight: true,
				pause: 6000,
				controls: false
			});
		}
	});

	// Slideshow
	$('.slideshow').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');
		if (element.children('.news-message-frontpage').length > 1) {
			element.lightSlider({
				item: 1,
				slideMargin: 0,
				addClass: cssClass,
				mode: 'fade',
				cssEasing: 'linear',
				auto: true,
				loop: true,
				adaptiveHeight: true,
				pause: 6000,
				controls: true
			});
		}
	});

	// Match height
	$('.news-message__title, .employee__field, .vacancy__title, .history__container').matchHeight({
		byRow: true,
		property: 'height'
	});

	$('.vacancy__container p, .employee__container').matchHeight({
		byRow: true,
		property: 'height'
	});

	// Open language on touch
	$('.languages').each(function () {
		var element = $(this);

		element.on("touchend", function (e) {
			element.toggleClass('open');
		});
	});

	// Lightbox
	$('#wrapper').lightGallery({
		selector: '[rel=lightbox]',
		download: false
	});

	// Route buttons
	$('.department__route-block').each(function () {
		var element = $(this);
		var routeButton = element.find('.button ').removeClass('hidden');
		var destinationAddress = element.find('.destination-address').removeClass('hidden');
		var address = routeButton.attr('data-address');

		routeButton.click(function () {
			route = {
				saddr: destinationAddress.val(),
				daddr: address
			};

			window.open('http://maps.google.nl/?' + $.param(route), '_blank');
		});
	});

	// Route form
	$('.form--route').each(function () {
		var element = $(this);
		var button = element.find('button');
		var destinationAddress = element.find('input[type=text]');
		var destination = element.find('.form--route__from-companies');

		// Route on button click
		button.click(function (e) {
			var route = {
				saddr: destinationAddress.val(),
				daddr: destination.val()
			};

			window.open('https://maps.google.com/?' + $.param(route), '_blank');

			e.preventDefault();
		});
	});

	// Google Maps
	$('.google-maps img').gmap3Upgrade({
		mapOptions: {
			zoom: 12,
			scrollwheel: false,
			// styles: [{ "featureType": "landscape", "stylers": [{ "hue": "#FFBB00" }, { "saturation": 43.400000000000006 }, { "lightness": 37.599999999999994 }, { "gamma": 1 }] }, { "featureType": "road.highway", "stylers": [{ "hue": "#FFC200" }, { "saturation": -61.8 }, { "lightness": 45.599999999999994 }, { "gamma": 1 }] }, { "featureType": "road.arterial", "stylers": [{ "hue": "#FF0300" }, { "saturation": -100 }, { "lightness": 51.19999999999999 }, { "gamma": 1 }] }, { "featureType": "road.local", "stylers": [{ "hue": "#FF0300" }, { "saturation": -100 }, { "lightness": 52 }, { "gamma": 1 }] }, { "featureType": "water", "stylers": [{ "hue": "#0078FF" }, { "saturation": -13.200000000000003 }, { "lightness": 2.4000000000000057 }, { "gamma": 1 }] }, { "featureType": "poi", "stylers": [{ "hue": "#00FF6A" }, { "saturation": -1.0989010989011234 }, { "lightness": 11.200000000000017 }, { "gamma": 1 }] }],
			streetViewControl: false
		},
		markerOptions: {
			clickable: false,
			icon: {
				url: (window.baseUrl || '/') + "images/marker-icon.png",
				anchor: {
					x: 35,
					y: 70
				},
				scaledSize: {
					width: 69,
					height: 70
				}
			}
		}
	});

	// Smooth scroll
	$('a[href*=\\#]').click(function () {
		var target = $(this.hash);

		if (!target.length) {
			target = $('[name=' + this.hash.slice(1) + ']');
		}

		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 500);

			return false;
		}
	});

	// Change target for external sites
	var getDomainName = function (hostName) {
		return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
	};
	$('a:not([target])').filter(function () {
		var link = $(this);
		if (link.filter('[rel~="external"]').length) return true; // Link rel attribute contains 'external'

		var href = link.attr('href');
		if (new RegExp('\.pdf$', 'i').test(href)) return true; // Link to PDF file

				if (new RegExp('^https?://', 'i').test(href)) {
			var linkHostName = getDomainName(href.substring(href.indexOf('/') + 2, href.indexOf('/', 8)));
			if (!new RegExp('(^|\.)' + getDomainName(document.location.hostname) + '$', 'i').test(linkHostName)) {
				// Link is to different domain name
				return true;
			}
		}

		return false;
	}).attr('target', '_blank');
});